/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Deep_Whale_DiveInputs */

const en_soft_deep_whale_dive = /** @type {(inputs: Soft_Deep_Whale_DiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detractors`)
};

const de_soft_deep_whale_dive = /** @type {(inputs: Soft_Deep_Whale_DiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detraktoren`)
};

/**
* | output |
* | --- |
* | "Detractors" |
*
* @param {Soft_Deep_Whale_DiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_deep_whale_dive = /** @type {((inputs?: Soft_Deep_Whale_DiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Deep_Whale_DiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_deep_whale_dive(inputs)
	return de_soft_deep_whale_dive(inputs)
});